module.exports = __webpack_public_path__ + "img/home.ffdbd83a.png";